<template>
    <el-popover
        placement="left"
        width="500"
        trigger="click"
        :ref="`UpgradelocalPresence${company.id}`">
        <el-form
            ref="change_rate_form"
            :model="local_presence_form">
            <el-form-item
                label="Line"
                class="mb-2">
                <el-select
                    v-model="local_presence_form.campaign_id"
                    :disabled="company.campaigns_with_local_presence.length === 0"
                    :placeholder="company.campaigns_with_local_presence.length > 0 ? 'Select Line' : 'No lines with local presence'"
                    class="w-full"
                    filterable>
                    <el-option
                        v-for="campaign in company.campaigns_with_local_presence"
                        :key="campaign.id"
                        :label="'#' + campaign.id + ' - ' + campaign.name"
                        :value="campaign.id">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-button
                type="success"
                class="w-full"
                :disabled="!local_presence_form.campaign_id"
                :loading="loading"
                @click.prevent="upgradeLocalPresence">
                <span>Upgrade</span>
            </el-button>
        </el-form>
        <button
            slot="reference"
            class="btn btn-sm btn-block green mt-2"
            :disabled="loading">
            Upgrade Local Presence
        </button>
    </el-popover>
</template>

<script>
import auth from "../../auth"

export default {
    name: "local-presence-upgrade",

    props: {
        company: {
            required: true,
            type: Object
        }
    },

    data() {
        return {
            auth: auth,
            loading: false,
            trigger: 'click',
            local_presence_form: {
                company_id: this.company.id,
                campaign_id: null,
            },
        }
    },

    created() {
        var _this = this

        VueEvent.listen('LOCAL_PRESENCE_UPGRADE', data => {
            const local_presence = _this.local_presence_options.find(lp => lp.prop === data.localPresencePurchase.type) || {}

            if (data.localPresencePurchase.status === LOCALPRESENCE.LP_STATUS_FINISHED) {
                this.$notify.success({
                    title: 'Local Presence Upgrade Complete',
                    message: `Account can now use Local Presence in ${local_presence.label}.`,
                    duration: 5000
                })
            }

            if (data.localPresencePurchase.status === LOCALPRESENCE.LP_STATUS_FAILED) {
                this.$notify.error({
                    title: 'Local Presence Upgrade Failed',
                    message: `Failed to upgrade Local Presence for this account in ${local_presence.label}.`,
                    duration: 5000
                })
            }

            this.$emit('upgraded', data.company)
        })
    },

    methods: {
        upgradeLocalPresence() {
            this.trigger = 'manual'

            this.$confirm(`Are you sure you want to upgrade local presence for this account?`, 'Upgrade Local Presence', {
                confirmButtonText: 'Yes, I\'m sure',
                cancelButtonText: 'No, I\'m not',
                customClass: 'width-500 fixed',
                type: 'info'
            }).then(res => {
                this.loading = true

                axios.post('/api/admin/company/upgrade-local-presence', this.local_presence_form)
                    .then((res) => {
                        this.loading = false

                        this.$notify.success({
                            title: 'Local Presence Upgrade Initiated',
                            message: res.data.message,
                            duration: 5000
                        })

                        this.$emit('upgraded', res.data.data)

                        this.resetForm()
                    }).catch(err => {
                    console.log(err)

                    this.$root.handleErrors(err.response)
                    this.loading = false

                    this.resetForm()
                })
            }).catch(err => {
                this.resetForm()
            })
        },

        resetForm() {
            this.local_presence_form = {
                company_id: this.company.id,
                campaign_id: null
            }

            this.trigger = 'click'
        }
    },

    watch: {
        'company.id'() {
            this.resetForm()
        }
    },

    beforeDestroy() {
        // destroy listeners
        VueEvent.unlisten('LOCAL_PRESENCE_UPGRADE')
    }
}
</script>
